import {GetOdontoProvidersModel} from 'domain/usecases';
import {formatAddress} from 'presentation/utils';

import {Units} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';
import {FlowEnum} from '../../shared/constants/flowEnum';

export const parseOdontoUnits = (units: GetOdontoProvidersModel): Units<FlowEnum.ODONTO>[] =>
	units?.unidades?.map(unit => ({
		code: unit?.codigo?.toString(),
		name: unit?.nome,
		stateCode: unit?.cdUf,
		city: unit?.nmCidade,
		addressNumber: unit?.numero?.toString(),
		addressName: unit?.logradouro,
		addressComplement: unit?.complemento,
		district: unit?.bairro,
		cep: unit?.cep,
		referencePoint: unit?.pontoReferencia,
		disability: unit?.cdAtendimentoAcessoEspecial,
		latitude: unit?.latitude,
		longitude: unit?.longitude,
		addressType: unit?.tpLogradouro,
		distance: unit?.distancia,
		formattedAddress: formatAddress({
			type: unit?.tpLogradouro,
			state: unit?.cdUf,
			city: unit?.nmCidade,
			number: unit?.numero?.toString(),
			address: unit?.logradouro,
			complement: unit?.complemento,
			district: unit?.bairro,
			zipCode: unit?.cep,
			reference: unit?.pontoReferencia,
		}),
	}));
